import React from 'react'
import { useNavigate } from 'react-router-dom'
import Gap from './Gap'
import { ReviewListType } from '../constants/reviewListType'

export interface DefaultFolderGridProps {
  userId: string
}

const DefaultFolderGrid: React.FC<DefaultFolderGridProps> = ({ userId }) => {
  const navigate = useNavigate()

  const renderGridItem = (title: string, icon: string, onClick: () => void) => {
    return (
      <div
        className={`
          w-full
          flex
          flex-col
          items-center
          justify-center
          cursor-pointer
        `}
        style={{ padding: '0 0 20.5px' }}
        onClick={onClick}
      >
        <img
          src={icon}
          alt={title}
          draggable={false}
          className={`
            w-full
            w-120px
            h-120px
            object-contain
            select-none
            [-webkit-touch-callout:none]
          `}
        />
        <Gap height={8} />
        <div className="font-pretendard font-regular text-14px leading-125% text-brown-80%-main text-ellipsis-1">
          {title}
        </div>
      </div>
    )
  }

  return (
    <div className="w-full grid grid-cols-2 gap-24px">
      {/* 경험한 장소 */}
      {renderGridItem(
        '경험한 장소',
        '/images/default-folder-experienced-icon.png',
        () => {
          navigate(`/reviews?userId=${userId}&type=${ReviewListType.REVIEWS}`)
        }
      )}

      {/* 저장한 장소 */}
      {renderGridItem(
        '저장한 장소',
        '/images/default-folder-saved-icon.png',
        () => {
          navigate(`/user/${userId}/saved-places`)
        }
      )}
    </div>
  )
}

export default DefaultFolderGrid
